import React from 'react';
import { ProcessHeader } from '../../../../components';
import { useHistory } from 'react-router-dom';

function useHeader(commands) {
  const history = useHistory();
  const goBack = (process, space) => commands.process.previousStep();
    //return history.push(`/${space?.nickname}`);
  

  return ({
    eventHandlers: {
      goBack,
    },
  });
}

export default function Header(props) {
  const { sharedStates, commands } = props;
  const { eventHandlers } = useHeader(commands);
  
  return (
    <>
      <ProcessHeader goBackAction={() => eventHandlers.goBack(sharedStates.process.controllers.status, sharedStates.space)} title= 'Resumo do Pedido'/>
    </>
  );
}
